const MAIN_MENU_LINKS = [
  { text: 'Sold', to: '/sold', styles: 'mb-5' },
  { text: 'About', to: '/about', styles: 'mt-5' },
  { text: 'Careers', to: '/careers' },
];

export default MAIN_MENU_LINKS;
